import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)``

export const Wrapper = styled(Container)``

export const Image = styled(CustomImage)`
  border-radius: 20px;
  overflow: hidden;
  .gatsby-image-wrapper {
    min-height: 291px;
  }

  img {
    object-fit: cover !important;
    width: 100%;
  }
`
